import { Box } from '@lemonade-hq/cdk';
import { COLORS } from '@lemonade-hq/tokens';
import styled, { css } from 'styled-components';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  box-sizing: border-box;\n  border-radius: 100%;\n  display: inline-block;\n  width: ",
        "em;\n  height: ",
        "em;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var STATUS_STYLES = {
    active: css(_templateObject(), COLORS.green),
    idle: css(_templateObject1(), COLORS.metal),
    pending: css(_templateObject2(), COLORS.orange),
    inactive: css(_templateObject3(), COLORS.red),
    inReview: css(_templateObject4(), COLORS.night)
};
var SIZE_MULTIPLIER = 0.86;
var StatusDot = styled(Box)(_templateObject5(), SIZE_MULTIPLIER, SIZE_MULTIPLIER, function(props) {
    return STATUS_STYLES[props.dotType];
});

export { StatusDot };
